module.exports = __webpack_public_path__ + "assets/img/dj_info.b1379cd9.png";